import axios from "axios";

export const baseURL = "https://api.dev.portfolio.finapp.kpbfincare.com/";

// Create an Axios instance with default settings
const API = axios.create({
  baseURL: "https://api.dev.portfolio.finapp.kpbfincare.com/",
  headers: {
    "Content-Type": "application/json",
  },
});

// Request Interceptor: Attach Authorization Token
API.interceptors.request.use(
  (config : any) => {
    const token = localStorage.getItem("token"); // Retrieve token from storage
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error : any) => {
    return Promise.reject(error);
  }
);

// Response Interceptor: Handle Global Errors
API.interceptors.response.use(
  (response : any) => response,
  (error : any) => {
    if (error.response) {
      if (error.response.status === 401) {
        console.error("Unauthorized! Redirecting to login...");
        // Optionally redirect to login page if unauthorized
        // window.location.href = "/login";
      }
    }
    return Promise.reject(error);
  }
);

export default API;
